import { asyncRoutes, constantRoutes } from '@/router'

// 判断是否有权限访问该菜单
function hasPermission(menus, route, mymenus) {
  if (route.name) {
    const currMenu = getMenu(route.name, menus, mymenus)
    if (currMenu != null) {
      // 设置菜单的标题、图标和可见性
      if (currMenu.title != null && currMenu.title !== '') {
        route.meta.title = currMenu.title
      }
      if (currMenu.icon != null && currMenu.title !== '') {
        route.meta.icon = currMenu.icon
      }
      if (currMenu.hidden != null) {
        route.hidden = currMenu.hidden !== 0
      }
      if (currMenu.sort != null && currMenu.sort !== '') {
        route.sort = currMenu.sort
      }
      return true
    } else {
      route.sort = 0
      if (route.hidden !== undefined && route.hidden === true) {
        return true
      } else {
        return false
      }
    }
  } else {
    return true
  }
}

// 根据路由名称获取菜单
function getMenu(name, menus, item) {
  for (let i = 0; i < menus.length; i++) {
    const menu = menus[i]
    if (name === menu.uri) {
      return menu
    }
  }
  // 如果只有一级给他添加第一个子菜单
  if (item) {
    if (item.level === 0) {
      for (let i = 0; i < menus.length; i++) {
        const menu = menus[i]

        if (item.name === menu.uri) {
          return menus[0]
        }
      }
    }
  }

  return null
}

// 对菜单进行排序
function sortRouters(accessedRouters) {
  for (let i = 0; i < accessedRouters.length; i++) {
    const router = accessedRouters[i]
    if (router.children && router.children.length > 0) {
      router.children.sort(compare('sort'))
    }
  }
  accessedRouters.sort(compare('sort'))
}

// 升序比较函数
function compare(p) {
  return function(m, n) {
    const a = m[p]
    const b = n[p]
    return a - b
  }
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routers) => {
    state.addRoutes = routers
    state.routes = constantRoutes.concat(routers)
  }
}

const actions = {
  generateRoutes({ commit }, data) {
    return new Promise(resolve => {
      const { menus, username } = data
      const accessedRouters = asyncRoutes.filter(v => {
        // admin帐号直接返回所有菜单
        if (username === 'admin') return true

        if (hasPermission(menus, v, '')) {
          if (v.children && v.children.length > 0) {
            v.children = v.children.filter(child => {
              if (hasPermission(menus, child, v)) {
                return child
              }
              return false
            })
            return v
          } else {
            return v
          }
        }
        return false
      })

      // 对菜单进行排序
      sortRouters(accessedRouters)
      commit('SET_ROUTES', accessedRouters)
      resolve(accessedRouters)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
